/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createUnplannedOt } from '../fn/ot-controller-v-2/create-unplanned-ot';
import { CreateUnplannedOt$Params } from '../fn/ot-controller-v-2/create-unplanned-ot';
import { CreateUnplannedOtResponse } from '../models/create-unplanned-ot-response';
import { differerOt } from '../fn/ot-controller-v-2/differer-ot';
import { DiffererOt$Params } from '../fn/ot-controller-v-2/differer-ot';
import { getOtById } from '../fn/ot-controller/get-ot-by-id';
import { GetOtById$Params } from '../fn/ot-controller/get-ot-by-id';
import { getOtMultiSitesGammes } from '../fn/ot-controller-v-2/get-ot-multi-sites-gammes';
import { GetOtMultiSitesGammes$Params } from '../fn/ot-controller-v-2/get-ot-multi-sites-gammes';
import { getOts } from '../fn/ot-controller-v-2/get-ots';
import { GetOts$Params } from '../fn/ot-controller-v-2/get-ots';
import { getOtsDoneForEquipement } from '../fn/ot-controller-v-2/get-ots-done-for-equipement';
import { GetOtsDoneForEquipement$Params } from '../fn/ot-controller-v-2/get-ots-done-for-equipement';
import { getOtsSearch } from '../fn/ot-controller/get-ots-search';
import { GetOtsSearch$Params } from '../fn/ot-controller/get-ots-search';
import { getOtsToDoForEquipement } from '../fn/ot-controller-v-2/get-ots-to-do-for-equipement';
import { GetOtsToDoForEquipement$Params } from '../fn/ot-controller-v-2/get-ots-to-do-for-equipement';
import { getUnplannedOts } from '../fn/ot-controller/get-unplanned-ots';
import { GetUnplannedOts$Params } from '../fn/ot-controller/get-unplanned-ots';
import { OtResponse } from '../models/ot-response';
import { suggestOt } from '../fn/ot-controller-v-2/suggest-ot';
import { SuggestOt$Params } from '../fn/ot-controller-v-2/suggest-ot';
import { SuggestOtResponse } from '../models/suggest-ot-response';

/**
 * Controller v2 des Ots
 */
@Injectable({ providedIn: 'root' })
export class OtControllerV2Api extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `suggestOt()` */
  static readonly SuggestOtPath = '/v2/ots/suggestions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `suggestOt()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  suggestOt$Response(
    params: SuggestOt$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<SuggestOtResponse>> {
    return suggestOt(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `suggestOt$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  suggestOt(params: SuggestOt$Params, context?: HttpContext): Observable<SuggestOtResponse> {
    return this.suggestOt$Response(params, context).pipe(
      map((r: StrictHttpResponse<SuggestOtResponse>): SuggestOtResponse => r.body)
    );
  }

  /** Path part for operation `createUnplannedOt()` */
  static readonly CreateUnplannedOtPath = '/v2/ots/create_unplanned_ot';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createUnplannedOt()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUnplannedOt$Response(
    params: CreateUnplannedOt$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<CreateUnplannedOtResponse>> {
    return createUnplannedOt(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createUnplannedOt$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUnplannedOt(params: CreateUnplannedOt$Params, context?: HttpContext): Observable<CreateUnplannedOtResponse> {
    return this.createUnplannedOt$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateUnplannedOtResponse>): CreateUnplannedOtResponse => r.body)
    );
  }

  /** Path part for operation `differerOt()` */
  static readonly DiffererOtPath = '/v2/ots/{id_ot}/differer';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `differerOt()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  differerOt$Response(params: DiffererOt$Params, context?: HttpContext): Observable<StrictHttpResponse<{}>> {
    return differerOt(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `differerOt$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  differerOt(params: DiffererOt$Params, context?: HttpContext): Observable<{}> {
    return this.differerOt$Response(params, context).pipe(map((r: StrictHttpResponse<{}>): {} => r.body));
  }

  /** Path part for operation `getOts()` */
  static readonly GetOtsPath = '/v2/ots';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOts$Response(params?: GetOts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OtResponse>>> {
    return getOts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOts(params?: GetOts$Params, context?: HttpContext): Observable<Array<OtResponse>> {
    return this.getOts$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OtResponse>>): Array<OtResponse> => r.body)
    );
  }

  /** Path part for operation `getOtById()` */
  static readonly GetOtByIdPath = '/v2/ots/{idOt}';

  /**
   * get.
   *
   * Recuperer l'ot
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOtById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOtById$Response(params: GetOtById$Params, context?: HttpContext): Observable<StrictHttpResponse<OtResponse>> {
    return getOtById(this.http, this.rootUrl, params, context);
  }

  /**
   * get.
   *
   * Recuperer l'ot
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOtById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOtById(params: GetOtById$Params, context?: HttpContext): Observable<OtResponse> {
    return this.getOtById$Response(params, context).pipe(
      map((r: StrictHttpResponse<OtResponse>): OtResponse => r.body)
    );
  }

  /** Path part for operation `getOtMultiSitesGammes()` */
  static readonly GetOtMultiSitesGammesPath = '/v2/ots/{idOt}/multi_sites_gammes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOtMultiSitesGammes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOtMultiSitesGammes$Response(
    params: GetOtMultiSitesGammes$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<OtResponse>>> {
    return getOtMultiSitesGammes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOtMultiSitesGammes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOtMultiSitesGammes(params: GetOtMultiSitesGammes$Params, context?: HttpContext): Observable<Array<OtResponse>> {
    return this.getOtMultiSitesGammes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OtResponse>>): Array<OtResponse> => r.body)
    );
  }

  /** Path part for operation `getUnplannedOts()` */
  static readonly GetUnplannedOtsPath = '/v2/ots/unplanned_ots';

  /**
   * get.
   *
   * Récupérer les Ot non-planifiés (générer, analyser, à communiquer) Orion.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUnplannedOts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnplannedOts$Response(
    params: GetUnplannedOts$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<OtResponse>>> {
    return getUnplannedOts(this.http, this.rootUrl, params, context);
  }

  /**
   * get.
   *
   * Récupérer les Ot non-planifiés (générer, analyser, à communiquer) Orion.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUnplannedOts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnplannedOts(params: GetUnplannedOts$Params, context?: HttpContext): Observable<Array<OtResponse>> {
    return this.getUnplannedOts$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OtResponse>>): Array<OtResponse> => r.body)
    );
  }

  /** Path part for operation `getOtsSearch()` */
  static readonly GetOtsSearchPath = '/v2/ots/search';

  /**
   * get.
   *
   * Récupérer les ots (avec ou sans filtre)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOtsSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOtsSearch$Response(params?: GetOtsSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return getOtsSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * get.
   *
   * Récupérer les ots (avec ou sans filtre)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOtsSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOtsSearch(params?: GetOtsSearch$Params, context?: HttpContext): Observable<string> {
    return this.getOtsSearch$Response(params, context).pipe(map((r: StrictHttpResponse<string>): string => r.body));
  }

  /** Path part for operation `getOtsToDoForEquipement()` */
  static readonly GetOtsToDoForEquipementPath = '/v2/ots/ots_to_do_for_equipement';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOtsToDoForEquipement()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOtsToDoForEquipement$Response(
    params: GetOtsToDoForEquipement$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<OtResponse>>> {
    return getOtsToDoForEquipement(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOtsToDoForEquipement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOtsToDoForEquipement(
    params: GetOtsToDoForEquipement$Params,
    context?: HttpContext
  ): Observable<Array<OtResponse>> {
    return this.getOtsToDoForEquipement$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OtResponse>>): Array<OtResponse> => r.body)
    );
  }

  /** Path part for operation `getOtsDoneForEquipement()` */
  static readonly GetOtsDoneForEquipementPath = '/v2/ots/ots_done_for_equipement';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOtsDoneForEquipement()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOtsDoneForEquipement$Response(
    params: GetOtsDoneForEquipement$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<OtResponse>>> {
    return getOtsDoneForEquipement(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOtsDoneForEquipement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOtsDoneForEquipement(
    params: GetOtsDoneForEquipement$Params,
    context?: HttpContext
  ): Observable<Array<OtResponse>> {
    return this.getOtsDoneForEquipement$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OtResponse>>): Array<OtResponse> => r.body)
    );
  }
}
